module.exports = __webpack_public_path__ + "static/img/framer.f9e76dfe.png";